if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableMobileCounter = this.dataset.enableMobileCounter === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.setSliderOptions();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          this.initImageZoom();
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);

        // Set up navigation - handle case where prev button might not exist
        // Desktop with thumbnails: use -main buttons (outside media-gallery)
        // Mobile or other layouts: use regular buttons (inside media-gallery)
        // Check if -main buttons are visible (desktop with thumbnails)
        const mainNextBtn = document.querySelector('.swiper-button-next-main');
        const isMainBtnVisible = mainNextBtn && window.getComputedStyle(mainNextBtn).display !== 'none';

        const nextButton = isMainBtnVisible ? mainNextBtn : this.querySelector('.swiper-button-next');
        const prevButton = isMainBtnVisible ? document.querySelector('.swiper-button-prev-main') : this.querySelector('.swiper-button-prev');
        const paginationEl = isMainBtnVisible ? document.querySelector('.swiper-pagination-main') : this.querySelector('.swiper-pagination');

        const navigation = {
          nextEl: nextButton,
        };

        // Only add prevEl if the button exists
        if (prevButton) {
          navigation.prevEl = prevButton;
        }

        this.sliderOptions = {
          init: false,
          slidesPerView: '1',
          spaceBetween: mediaItemGap,
          loop: !this.onlyImage,
          grabCursor: !this.onlyImage,
          allowTouchMove: !this.onlyImage,
          autoHeight: true,
          navigation: navigation,
          pagination: {
            el: paginationEl,
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 6,
            },
          },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              direction: 'vertical',
              slidesPerView: 'auto',
              freeMode: false,
              allowTouchMove: false,
              grabCursor: false,
              breakpoints: {},
              navigation: {
                nextEl: this.querySelector('.thumb-rail-next'),
                prevEl: this.querySelector('.thumb-rail-prev'),
              },
            });
            // Main image swaps instantly on thumbnail click — no drag/swipe on desktop,
            // only zoom click is the intended interaction on the main image.
            // Mobile keeps touch enabled so the counter/peek slider (JMS-496) works.
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              speed: 0,
              breakpoints: Object.assign({}, this.sliderOptions.breakpoints, {
                768: {
                  allowTouchMove: false,
                  grabCursor: false,
                },
              }),
            });
            break;
          case 'slider-freemode':
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: 'auto',
            });
            break;
        }

        if (this.enableMobileCounter) {
          this.sliderOptions = Object.assign({}, this.sliderOptions, {
            breakpoints: {
              0: {
                slidesPerView: 1.2,
                spaceBetween: 6,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: mediaItemGap,
              },
            },
          });
        }
      }

      updateSliderNavigation() {
        // Update button references based on current visibility
        const mainNextBtn = document.querySelector('.swiper-button-next-main');
        const isMainBtnVisible = mainNextBtn && window.getComputedStyle(mainNextBtn).display !== 'none';

        const nextButton = isMainBtnVisible ? mainNextBtn : this.querySelector('.swiper-button-next');
        const prevButton = isMainBtnVisible ? document.querySelector('.swiper-button-prev-main') : this.querySelector('.swiper-button-prev');
        const paginationEl = isMainBtnVisible ? document.querySelector('.swiper-pagination-main') : this.querySelector('.swiper-pagination');

        console.log('MediaGallery: updateSliderNavigation', {
          isMainBtnVisible,
          nextButton,
          prevButton,
          paginationEl
        });

        // Ensure navigation object exists
        if (!this.sliderOptions.navigation) {
          this.sliderOptions.navigation = {};
        }

        // Update navigation in slider options
        this.sliderOptions.navigation.nextEl = nextButton;
        if (prevButton) {
          this.sliderOptions.navigation.prevEl = prevButton;
        }

        // Ensure pagination object exists
        if (!this.sliderOptions.pagination) {
          this.sliderOptions.pagination = { clickable: true, type: 'fraction' };
        }
        this.sliderOptions.pagination.el = paginationEl;
      }

      updateMediaLayout() {
        // Destroy and reinitialize slider on layout change to update button references
        if (this.sliderInstance) {
          this.destroySlider();
        }

        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider || this.elements.thumbnails) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          // Update slider options with current button visibility state
          this.updateSliderNavigation();

          console.log('MediaGallery: Creating Swiper with navigation:', this.sliderOptions.navigation);

          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            const thumbModules = this.mediaLayout === 'vertical-carousel' ? [FoxTheme.Swiper.Navigation] : [];
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions, thumbModules);
            this.thumbsInstance.init();

            // Vertical carousel: don't connect via the Swiper thumbs module — the rail must
            // only move when arrow buttons are clicked, never on thumbnail click or slide change.
            if (this.mediaLayout !== 'vertical-carousel') {
              this.sliderOptions.thumbs = {
                swiper: this.thumbsInstance.slider,
                autoScrollOffset: 2,
              };
            }
          }

          const mainModules = this.mediaLayout === 'vertical-carousel' ? [] : [FoxTheme.Swiper.Thumbs];
          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, mainModules);
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          if (this.mediaLayout === 'vertical-carousel' && this.elements.thumbnails) {
            this.initVerticalThumbClicks();
            this.setActiveThumb(0);
          }

          this.sliderInstance.slider.init();

          // Remove zoom buttons from tab order. Tab landing on a non-active slide's
          // zoom button causes the Swiper to scroll that element into view, revealing
          // the adjacent slide. PhotoSwipe handles its own keyboard nav once open.
          this.elements.viewer.querySelectorAll('.js-photoswipe--zoom').forEach(el => {
            el.setAttribute('tabindex', '-1');
          });
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
        if (allMedia) {
          allMedia.forEach((media) => {
            switch (media.dataset.mediaType) {
              case 'model':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'video':
              case 'external_video':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'image':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
        });

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el.src;
              }
            }
          }

          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
        });

        this.lightbox.on('destroy', () => {
          const { currIndex } = this.lightbox.pswp;

          setTimeout(() => {
            // Strip stale PhotoSwipe listeners from zoom elements by cloning them.
            // addEventDelegate is on the media-gallery element (not the zoom els directly),
            // so cloning is safe — the delegate still catches clicks via CSS selector matching.
            this.querySelectorAll('.js-photoswipe--zoom').forEach(el => {
              el.parentNode.replaceChild(el.cloneNode(true), el);
            });

            this.destroySlider();
            this.initSlider();
            if (this.sliderInstance && this.sliderInstance.slider) {
              this.sliderInstance.slider.slideToLoop(currIndex, 0, false);
            }
          }, 50);
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex] && (this.mediaLayout !== 'vertical-carousel' || window.innerWidth < 768)) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (this.mediaLayout === 'vertical-carousel') {
            // Update active class on thumbnails without moving the rail
            this.setActiveThumb(swiper.realIndex);
          } else if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);

            if (this.mediaLayout !== 'vertical-carousel' || window.innerWidth < 768) {
              const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
              this.toggleSliderDraggableState(!isModelMediaType);
            }
          }

        });
      }

      setActiveThumb(index) {
        const thumbItems = [...this.elements.thumbnails.querySelectorAll('.product__thumbs-item')];
        thumbItems.forEach((t, i) => {
          t.classList.toggle('swiper-slide-thumb-active', i === index);
          t.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      initVerticalThumbClicks() {
        // Remove tabindex from Swiper clone slides (created by loop:true) so they
        // don't receive keyboard focus — only real slides should be reachable via Tab.
        this.elements.thumbnails.querySelectorAll('.swiper-slide-duplicate').forEach(el => {
          el.removeAttribute('tabindex');
        });

        const thumbItems = [...this.elements.thumbnails.querySelectorAll('.product__thumbs-item:not(.swiper-slide-duplicate)')];
        thumbItems.forEach((item, index) => {
          item.addEventListener('click', () => {
            this.sliderInstance.slider.slideToLoop(index, 0, false);
            this.setActiveThumb(index);
          });
          item.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.sliderInstance.slider.slideToLoop(index, 0, false);
              this.setActiveThumb(index);
            }
          });
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      setActiveMedia(variant) {
        if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;

        if (this.sliderInstance.slider) {
          const slideIndex = variant.featured_media.position || 0;
          this.sliderInstance.slider.slideToLoop(slideIndex - 1);
        } else {
          this.sortMediaItems(variant);
        }
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile) {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}
